(function () {
  var marketData = document.getElementById('kd-market-data');
  var isHKMarket = marketData && marketData.dataset.marketHandle === 'hk';
  if (document.querySelector('kd-welcome-offer')) return;

  // For non-HK visitors: remove false sold-out badges
  if (!isHKMarket) {
    function removeFalseBadges() {
      document.querySelectorAll('.badge--sold-out').forEach(function(badge) {
        badge.remove();
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', removeFalseBadges);
    } else {
      removeFalseBadges();
    }
    var observer = new MutationObserver(function() { removeFalseBadges(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Popup only exists for non-HK market (rendered conditionally in Liquid)
  var popup = document.getElementById('kd-market-popup');
  if (!popup) return;

  function open() { popup.classList.add('is-open'); }
  function close() { popup.classList.remove('is-open'); }

  popup.querySelector('.kd-mkt__overlay').addEventListener('click', close);
  popup.querySelector('.kd-mkt__close').addEventListener('click', close);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });

  // Intercept add-to-cart form submits (single-variant quick add)
  document.addEventListener('submit', function(e) {
    if (e.target.closest('product-form') && e.target.dataset.type === 'add-to-cart-form') {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }
  }, true);

  // Intercept multi-variant quick-add drawer opener
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('quick-add-drawer-opener .quick-add__submit');
    if (btn && !btn.disabled) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }
  }, true);

  // Intercept PDP add-to-cart button
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[name="add"]');
    if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }
  }, true);

  // Intercept PDP Buy Now button (type="button", no name attr — posts to /cart/add.js directly)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.kd-buy-now');
    if (btn && !btn.disabled) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }
  }, true);
})();
